import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

import { UsuarioService } from './usuarios.service';
import { Usuario } from './../usuario/usuario';

declare var Materialize:any;

@Component({
  selector: 'app-lembra-senha',
  templateUrl: './lembra-senha.component.html',
  styleUrls: ['./usuarios.component.css'],
  providers: [UsuarioService]
})
export class LembraSenhaComponent implements OnInit, AfterViewChecked {
  public titulo: string = "Lembrar Senha";
  public usuario: Usuario;

  constructor(private usuarioService: UsuarioService) {
    this.usuario = new Usuario();
  }

  lembra_senha(): void{
    this.usuarioService.lembrarSenha(this.usuario);
  }

  ngOnInit() {
  }

  ngAfterViewChecked() {
    Materialize.updateTextFields();
  }

}



// WEBPACK FOOTER //
// ./src/app/usuarios/lembra-senha.component.ts